/**
 * Fetcher & mutator pure functions untuk users domain.
 *
 * Subdomain:
 *   - user        → admin/user akun (CRUD, import)
 *   - agen        → admin agen (CRUD)
 *   - karyawan    → CRUD
 *   - member      → CRUD
 *   - role        → list, get
 */
import http from "@/config/http";

/* ============================================================
 * Users (admin/staff akun)
 * ============================================================ */

export async function fetchUsers(params = {}) {
  const { data } = await http.get("/api/v1/users/user", { params });
  return data;
}

export async function fetchUserById(id) {
  const { data } = await http.get(`/api/v1/users/user/get/${id}`);
  return data;
}

export async function createUser(payload) {
  const { data } = await http.post("/api/v1/users/user/create", payload);
  return data;
}

export async function updateUser({ id, payload }) {
  const { data } = await http.put(`/api/v1/users/user/update/${id}`, payload);
  return data;
}

export async function deleteUser(id) {
  const { data } = await http.delete(`/api/v1/users/user/delete/${id}`);
  return data;
}

export async function deleteAllUsers() {
  const { data } = await http.delete("/api/v1/users/user/delete-all");
  return data;
}

export async function importUsers(payload, config = {}) {
  const { data } = await http.post(
    "/api/v1/users/user/import",
    payload,
    config
  );
  return data;
}

/* ============================================================
 * Agen
 * ============================================================ */

export async function fetchAgen(params = {}) {
  const { data } = await http.get("/api/v1/users/agen/get", { params });
  return data;
}

export async function fetchAgenById(id) {
  const { data } = await http.get(`/api/v1/users/agen/get/${id}`);
  return data;
}

export async function createAgen(payload) {
  const { data } = await http.post("/api/v1/users/agen/create/admin", payload);
  return data;
}

export async function updateAgen({ id, payload }) {
  const { data } = await http.put(`/api/v1/users/agen/update/${id}`, payload);
  return data;
}

export async function deleteAgen(id) {
  const { data } = await http.delete(`/api/v1/users/agen/delete/${id}`);
  return data;
}

/* ============================================================
 * Karyawan
 * ============================================================ */

export async function fetchKaryawan(params = {}) {
  const { data } = await http.get("/api/v1/users/karyawan/get", { params });
  return data;
}

export async function fetchKaryawanById(id) {
  const { data } = await http.get(`/api/v1/users/karyawan/get/${id}`);
  return data;
}

export async function createKaryawan(payload) {
  const { data } = await http.post(
    "/api/v1/users/karyawan/create/admin",
    payload
  );
  return data;
}

export async function updateKaryawan({ id, payload }) {
  const { data } = await http.put(
    `/api/v1/users/karyawan/update/${id}`,
    payload
  );
  return data;
}

export async function deleteKaryawan(id) {
  const { data } = await http.delete(`/api/v1/users/karyawan/delete/${id}`);
  return data;
}

/* ============================================================
 * Member
 * ============================================================ */

export async function fetchMembersList(params = {}) {
  const { data } = await http.get("/api/v1/users/member/get", { params });
  return data;
}

export async function fetchMemberById(id) {
  const { data } = await http.get(`/api/v1/users/member/get/${id}`);
  return data;
}

export async function createMember(payload) {
  const { data } = await http.post(
    "/api/v1/users/member/create/admin",
    payload
  );
  return data;
}

export async function updateMember({ id, payload }) {
  const { data } = await http.put(`/api/v1/users/member/update/${id}`, payload);
  return data;
}

export async function deleteMember(id) {
  const { data } = await http.delete(`/api/v1/users/member/delete/${id}`);
  return data;
}

/* ============================================================
 * Role
 * ============================================================ */

export async function fetchRolesList(params = {}) {
  const { data } = await http.get("/api/v1/users/role", { params });
  return data;
}

export async function fetchRoleById(id) {
  const { data } = await http.get(`/api/v1/users/role/${id}`);
  return data;
}
